/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Locale} from '../models/Locale';

export interface UpdateAccountLocale$Request {
    accountId: number;
    locale: Locale;
}

export interface UpdateAccountLocale$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountLocaleRequest = createAction<PayloadData<void, UpdateAccountLocale$Request>>('UPDATE_ACCOUNT_LOCALE__UPDATE_ACCOUNT_LOCALE__REQUEST');
export const updateAccountLocaleSuccess = createAction<PayloadData<void, UpdateAccountLocale$Request>>('UPDATE_ACCOUNT_LOCALE__UPDATE_ACCOUNT_LOCALE__SUCCESS');
export const updateAccountLocaleFailure = createAction<PayloadData<Error, UpdateAccountLocale$Request, true>>('UPDATE_ACCOUNT_LOCALE__UPDATE_ACCOUNT_LOCALE__FAILURE');

export const updateAccountLocaleActions = [
    updateAccountLocaleRequest,
    updateAccountLocaleSuccess,
    updateAccountLocaleFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Locale} meta.locale
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountLocale = (meta: UpdateAccountLocale$Request, config?: UpdateAccountLocale$Config) => {
    return {
        CALL_API: {
            types: updateAccountLocaleActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/locales`,
            TRANSPORT_REQUEST_BODY: meta.locale,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

